<template>
  <div class="quotation-generator">
    <h1 id="title">{{$t('qg.titles.main')}}</h1>
    <button id="create-button" @click="startQuotation">{{$t('qg.buttons.create')}}</button>
    <div id="quote-array" class="array" v-if="newQuotation">
      <div id="tasks">
        <div v-bind:class="{ 'tasks-header': newQuotation.tasks && newQuotation.tasks.length === 0 }">
          {{ $t('qg.titles.tasks') }}
        </div>
        <div class="line quotation-line" v-bind:key="task._id" v-for="task in newQuotation.tasks">
          <span>{{ task.summary }}</span><span class="col">{{ task.workload }}</span>
        </div>
      </div>
      <div id="total" class="line quotation-line">
        <span>{{ $t('crud.quotation.labels.total') }}</span><span class="col">{{ newQuotation.amount }}€</span>
      </div>
    </div>
    <div id="tasks-list" class="array" v-if="newQuotation">
      <div v-bind:class="{ 'tasks-header': tasksList && tasksList.length === 0 }">
        {{ $t('qg.titles.tasksList') }}
      </div>
      <div v-bind:key="task._id" v-for="task in tasksList" class="line tasks-list-line">
        <span class="tasks-list-cell">{{ task.summary }}</span>
        <span class="tasks-list-cell col">{{ task.workload }} jours</span>
        <span class="tasks-list-cell col"><Checkbox v-model="task.checked" :binary="true" /></span>
      </div>
      <div class="line">
        <button @click="addTasks">{{$t('qg.buttons.addTasks')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
  import Checkbox from 'primevue/checkbox';
  import Quotation from "../models/quotation.model";

  export default {
  name: 'QuotationGenerator',
    components: {
      Checkbox
    },
    props: {},
    data: () => {
      return {
        newQuotation: null,
        tasksList: [
          {
            _id: 0,
            workload: 5,
            summary: 'Mettre en place l\'environnement',
            description: 'Créer l\'API de base, l\'application client de base et la base de données',
            checked: false
          },
          {
            _id: 1,
            workload: 3,
            summary: 'Design d\'une page',
            description: 'Faire le style d\'une page',
            checked: false
          },
          {
            _id: 2,
            workload: 0.5,
            summary: 'Ajout d\'un champ d\'entité',
            description: 'Ajouter un champ à une entité en base, ajouter une colonne dans le tableau et un input dans le formulaire dans la page d\'administration',
            checked: false
          },
          {
            _id: 3,
            workload: 5,
            summary: 'Création d\'une page spécifique',
            description: 'Créer la page sur la page, travailler l\'ergonomie, créer les algorythme, développer la page (la charge est une moyenne et peux varier selon la complexité)',
            checked: false
          },
          {
            _id: 4,
            workload: 5,
            summary: 'Ajout entité',
            description: 'Ajouter une entité en base, créer la page d\'administration',
            checked: false
          },
        ]
      }
    },
  methods: {
    startQuotation: function() {
      this.newQuotation = new Quotation();
    },
    addTasks: function() {
      let tasks = this.lodash.cloneDeep(this.tasksList.filter(t => t.checked));
      let index = this.newQuotation.tasks.length;
      for (let task of tasks) {
        task._id = index;
        index++;
      }
      this.newQuotation.setTasks([...this.newQuotation.tasks, ...tasks]);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .quotation-generator {
    display: grid;
    height: 100%;
    grid-template-columns: 1fr 30%;
    grid-template-rows: 50px 50px 1fr;
    grid-template-areas:
        'title title'
        'createButton createButton'
        'quoteArray tasksList';
  }
  .array {
    border: 1px solid black;
    margin-top: 10px;
  }
  #title {
    grid-area: title;
  }
  #create-button {
    grid-area: createButton;
    width: 200px;
    height: 20px;
    place-self: center;
  }
  #quote-array {
    grid-area: quoteArray;
    margin: 0 2%;
    width: 96%;
    place-self: self-start;
  }
  #tasks {
    min-height: 50px;
  }
  #tasks-list {
    grid-area: tasksList;
    margin: 0 2%;
    width: 96%;
    place-self: self-start;
  }
  .tasks-header {
    border-bottom: 1px solid black;
  }
  .line {
    border-top: 1px solid black;
  }
  .quotation-line {
    display: grid;
    grid-template-columns: 85% 15%;
  }
  .tasks-list-line {
    display: grid;
    grid-template-columns: 1fr 100px 50px;
  }
  .tasks-list-cell {
    padding: 5px;
  }
  .col {
    border-left: 1px solid black;
  }
</style>
